import React from 'react';
import withView from '../../../../cmn/docAutomation/withView';
import FormLauncher from '../../../../cmn/docAutomation/FormLauncher';
import useViewSwitcher from '../../../../../library/hooks/switch/useViewSwitcher'
import SarasViewSwitch from '../../../../../library/hooks/switch/SarasViewSwitch'
import SarasTabsSwitch from '../../../../../library/repeater/tabs/SarasTabsSwitch'
import { UiForm } from "../../../../../library/layout/Index";

const ProdTaskDetail = (props) => {
    const { viewMap, viewData, viewSwitcher, ...restProps } = props;
    const rmViewSwitcher = useViewSwitcher("issue");

    const issueGroups = [
        { key: "issue", val: "Input", isDefault: 1 },
        { key: "output", val: "Output" },
        { key: "waste", val: "Wastage" }
    ]

    //remove the screen if selected task is 0
    if(props.selectedTask === 0) return null;

    return (
        <>
            <UiForm formName="taskHeader">
                <FormLauncher viewMap={viewMap} viewSwitcher={viewSwitcher} compositionKey="taskHeader" 
                viewData={viewData} {...restProps}></FormLauncher>
            </UiForm>
            <SarasTabsSwitch viewSwitcher={rmViewSwitcher} switches={issueGroups} hotKeyPrefix="ctrl"/>
            <SarasViewSwitch viewSwitcher={rmViewSwitcher} ctrlKey='issue' hideMode='soft' >
                <UiForm formName="issuedMaterial">
                    <FormLauncher viewMap={viewMap} viewSwitcher={viewSwitcher} compositionKey="taskInput" viewData={viewData} {...restProps}></FormLauncher>
                </UiForm>
            </SarasViewSwitch>
            <SarasViewSwitch viewSwitcher={rmViewSwitcher} ctrlKey='output' hideMode='soft' >
                <UiForm formName="Output">
                    <FormLauncher viewMap={viewMap} viewSwitcher={viewSwitcher} compositionKey="taskOutput" viewData={viewData} {...restProps}></FormLauncher>
                </UiForm>
            </SarasViewSwitch>
            <SarasViewSwitch viewSwitcher={rmViewSwitcher} ctrlKey='waste' hideMode='soft' >
                <UiForm formName="Wastage">
                    <FormLauncher viewMap={viewMap} viewSwitcher={viewSwitcher} compositionKey="taskWaste" viewData={viewData} {...restProps}></FormLauncher>
                </UiForm>
            </SarasViewSwitch>
        </>
    )
}

export default withView(ProdTaskDetail, "prodTask");